module.exports = __webpack_public_path__ + "static/media/5-2.b95c4b8e.mp3";